import historyCheck from 'aurora-images/history_check.svg';
const styles = theme => ({
  titleHead: {
    background: 'none',
    color: '#342D3D',
    display: 'flex',
    alignItems: 'center',
    padding: '10px 15px',
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid #CED1D6',
    },
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid #CED1D6',
    },
    [theme.breakpoints.down('md')]: {},
  },
  Title: {
    fontWeight: '600',
    marginBottom: '0',
    fontSize: '16px',
  },
  paperCardFrame: {
    marginBottom: '7px',
    borderRadius: '0px',
    [theme.breakpoints.down('sm')]: {
      border: '0',
    },
  },
  innerCardGrid: {
    padding: '16px 9px 16px 16px',
    '& h6': {
      fontSize: '14px',
    },
  },
  lightClr: {
    color: '#484456',
  },
  darkClr: {
    color: '#130F26',
  },
  font14: {
    fontSize: '14px',
  },
  font12: {
    fontSize: '12px',
  },
  font16: {
    fontSize: '16px',
  },
  mt8: {
    marginTop: '8px',
  },
  fontW500: {
    fontWeight: '500',
  },
  fontW600: {
    fontWeight: '600',
  },
  applicationDetailsListNew: {
    fontWeight: '400',
    fontSize: '16px',
    color: '#130F26',
    width: '100%',
    marginLeft: '-22px',
    position: 'relative',
    marginTop: '5px',
    '& $timeCls': {
      lineHeight: '18px',
      marginTop: '2px',
    },
    '& $timeClsWrapper': {
      float: 'left',
    },
    '& $statusCls': {
      [theme.breakpoints.down('sm')]: {
        flexBasis: '30%',
      },
      [theme.breakpoints.up('sm')]: {
        flexBasis: '15%',
      },
      [theme.breakpoints.up('md')]: {
        flexBasis: '38%',
      },
    },
    '& $timeWrapper': {
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
      },
    },
    '& .MuiAccordionSummary-root.Mui-expanded': {
      minHeight: 'auto',
    },
    '& $dividerFirstCls': {
      margin: '16px 0px 0px',
      background: '#EBEEF3',
      height: '3px',
    },
    '& $dividerCls': {
      margin: '16px 0px 10px',
      background: '#EBEEF3',
    },
    '& li': {
      listStyle: 'none',
    },
    '& > li': {
      '&:last-child': {
        borderLeft: 'none',
        '&:before': {
          left: '-8px',
        },
      },
    },
    '& $completeStage': {
      position: 'relative',
      listStyle: 'none',
      borderLeft: '2px solid #008558',
      padding: '0px 0px 16px 18px',
      marginBottom: '-8px',
      '&:before': {
        content: `url(${historyCheck})`,
        background: '#008558',
        height: '20px',
        width: '20px',
        borderRadius: '20px',
        position: 'absolute',
        left: '-10px',
        top: '0px',
      },
    },
    '& $inCompleteStage': {
      position: 'relative',
      listStyle: 'none',
      borderLeft: '2px solid #8C9099',
      padding: '0px 0px 16px 18px',
      marginBottom: '-8px',
      '&:before': {
        background: '#8C9099',
        content: '""',
        left: '-10px',
        height: '20px',
        width: '20px',
        borderRadius: '20px',
        position: 'absolute',
        top: '0px',
      },
    },

    '& $iconCls': {
      width: '16px',
      height: '16px',
      marginRight: '5px',
    },
    '& $accordian': {
      padding: '0px',
      boxShadow: 'none',
      background: '#F8F8F8',
      marginTop: '0px',
      '& ul': {
        padding: '0px',
        margin: '0px',
        width: '100%',
      },
      '& $appStatus': {
        display: 'flex',
        flexDirection: 'row',
        fontSize: '12px',
        '& div': {
          marginTop: '8px',
        },
        '& $dotCls': {
          width: '8px',
          height: '8px',
          borderRadius: '10px',
          display: 'block',
          marginTop: '3px',
          marginRight: '6px',
          float: 'left',
        },
      },
      '& .MuiAccordionSummary-content': {
        display: 'flex',
        flexDirection: 'column',
        margin: '0px !important',
      },
      '& .MuiCollapse-entered': {
        marginTop: '-10px',
      },
      '& .MuiAccordionSummary-expandIcon': {
        top: '-10px !important',
        right: '-6px',
        position: 'absolute',
      },
      '& .MuiAccordionDetails-root': {
        padding: '0px',
        background: '#ffffff',
      },
      '& $blueClr': {
        background: '#096BCE',
      },
      '& $greenClr': {
        background: '#019F9F',
      },
      '& $orangeClr': {
        background: '#D97706',
      },
      '& $redClr': {
        background: '#DF2C2C',
      },
      '& $accordianSummary': {
        padding: '0px',
        background: '#ffffff',
        position: 'relative',
      },
      '& $accordianDetails': {
        padding: '0px',
        marginTop: '-20px',
        '& li': {
          listStyleType: 'none',
          margin: '10px 0px',
        },
      },
    },
    '& $accordianLi': {
      listStyleType: 'none',
      marginTop: '8px',
      '& $title': {
        color: '#130F26',
        fontSize: '16px',
        width: '90%',
      },
      position: 'relative',
      background: '#ffffff',
    },
  },
  redClr: {},
  completeStage: {},
  inCompleteStage: {},
  statusCls: {},
  timeCls: {},
  dividerFirstCls: {},
  dotCls: {},
  appStatus: {},
  accordian: {},
  accordianLi: {},
  iconCls: {},
  dividerCls: {},
  blueClr: {},
  greenClr: {},
  orangeClr: {},
  accordianDetails: {},
  accordianSummary: {},
  timeClsWrapper: {},
  timeWrapper: {},
  title: {},
  [theme.breakpoints.up('md')]: {
    Title: {
      fontSize: '24px',
    },
    titleHead: {
      padding: '16px 24px',

      '& $Title': {
        fontSize: '18px',
        fontWeight: 600,
      },
    },
    paperCardFrame: {
      marginBottom: '24px',
    },
    innerCardGrid: {
      '& h6': {
        fontSize: '1rem',
      },
    },
  },

  [theme.breakpoints.down('960')]: {
    Title: {
      fontSize: '24px',
    },
    titleHead: {
      padding: '16px 24px',
      background: theme.palette.primary.journeyBG,
      '& $Title': {
        fontSize: '18px',
        fontWeight: 600,
      },
    },
    paperCardFrame: {
      marginBottom: '24px',
    },
    innerCardGrid: {
      '& h6': {
        fontSize: '1rem',
      },
    },
  },
});

export default styles;
